<template>
  <div class="container">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section section-evento">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div class="form">
        <b-form>
          <b-form-group>
            <b-form-select 
              v-model="eventoNombre" 
              :options="eventosList"
              class="mb-3">
              <template slot="first">
                <option :value="null" disabled>Seleccione un evento</option>
              </template>
            </b-form-select>                 
            <b-form-invalid-feedback id="eventoFeedback">
              {{ eventoInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
        </b-form>
      </div>
      <div>
        <b-button class="link"
          @click.prevent="seleccionarEvento">ENVIAR</b-button>
      </div> 
    </div>
    <b-alert
      v-model="error"
      variant= "warning">
      <p>{{ errorMessage }}</p>
    </b-alert>    
  </div>
</template>

<script>
export default {
  data () {
    return {
      eventos: [],
      eventosList: [],
      eventoNombre: null,

      eventoInvalidoMsj: '',
      error: false,
      errorMessage: ''
    }
  },
  created () {
    if (!this.$store.getters['user/loggedIn']) {
      this.$router.push({ name: 'Login' });
    }
    
    this.$store.dispatch('eventos/getEventos')
      .then(response => {
        this.eventos = this.$store.getters['eventos/eventos'];
        this.eventosList = this.$store.getters['eventos/eventosList'];

        var evento = this.$store.getters['eventos/evento'];
        if (evento) {
          this.eventoNombre = evento.nombre;
        }

      })
      .catch( error => {
        this.error = true;
        this.errorMessage = error;
      });
  },
  methods: {
    seleccionarEvento () {
      var eventoSeleccionado = false;
      if (this.eventoNombre) {
        var evento = this.getSelected(this.eventos, this.eventoNombre);
        if (evento) {
          eventoSeleccionado = true;
        }
      }

      if (eventoSeleccionado) {
          this.$store.dispatch('eventos/setEvento', evento);
          this.$router.push({ name: 'SeleccionMetodo' });
      } else {
        this.eventoInvalidoMsj = 'Seleccione el evento para continuar';
      }
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    },
    back () {
      this.$router.push({ name: 'Inicio' });
    }
  },
  watch: {
    'eventoNombre' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.eventoInvalidoMsj = ''; 
      }
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SeleccionEvento.vue